import {ApolloLink} from 'apollo-link';

const PREFETCHED_QUERIES = ['SearchQuery'];

const isPrefetchOperation = (operation) =>
    PREFETCHED_QUERIES.includes(operation.operationName);

export class PrefetchLink extends ApolloLink {
    constructor() {
        super();
        this.isPageLoadSearch = true;
    }
    request(operation, forward) {
        if (isPrefetchOperation(operation)) {
            operation.extensions.isPageLoadSearch = this.isPageLoadSearch;
            this.isPageLoadSearch = false;
        }
        return forward(operation);
    }
}
